import request from './request';

export const aiAPI = {
  // AI文案生成
  generate: (data) => request.post('/ai/generate', data),
  // 流式生成
  generateStream: (params) => `/api/mediacross/v1/ai/generate/stream?${new URLSearchParams(params)}`,
  // 翻译
  translate: (data) => request.post('/ai/translate', data),
  // SEO关键词
  extractKeywords: (data) => request.post('/ai/keywords', data),
  // Listing优化
  optimizeListing: (data) => request.post('/ai/optimize-listing', data),
};

export default aiAPI;
